import {FC, useState} from 'react';
import {IProgram} from '../../../models/program';
import {ISubstrateOption} from '../../../models/substrateOption';
import {useAppDispatch} from '../../../store/app-hooks';
import {useNotification} from '../../../store/notification/NotificationContext';
import {
    addProgramToSubstrateOption,
    removeProgramFmSubstrateOption,
} from '../../../store/substrateOptions/substrateOptionSlice';
import {ToggleChip} from '../../UI/Chips/ToggleChip';
import {DataConfigCard} from '../../shared/DataConfigCard';
import SubstrateOptionModal from '../../shared/SubstrateOptionsModal';

import {FIELD_LABELS} from '../../../constants';

const {FAIL_OPERATION} = FIELD_LABELS;

interface IProps {
    program: IProgram;
    options: ISubstrateOption[];
}

const ProgramSubstrateOptions: FC<IProps> = ({program, options}) => {
    const [openModal, setOpenModal] = useState(false);
    const {addNotification} = useNotification();
    const dispath = useAppDispatch();

    const handleAddOption = (option_id: string) => {
        dispath(addProgramToSubstrateOption({option_id, data: {programId: program.id}}))
            .unwrap()
            .catch(() => addNotification(FAIL_OPERATION, 'error'));
    };

    const handleRemoveOption = (option_id: string) => {
        dispath(removeProgramFmSubstrateOption({option_id, data: {programId: program.id}}))
            .unwrap()
            .catch(() => addNotification(FAIL_OPERATION, 'error'));
    };

    return (
        <>
            <DataConfigCard
                title="SUBSTRATE OPTIONS FOR LOCATION"
                onAddNew={() => setOpenModal(true)}
            >
                {options.map((option) => (
                    <ToggleChip
                        key={option.id}
                        label={option.title}
                        selected={option.programs.includes(program.id)}
                        onClick={() =>
                            option.programs.includes(program.id)
                                ? handleRemoveOption(option.id)
                                : handleAddOption(option.id)
                        }
                    />
                ))}
            </DataConfigCard>
            {openModal && (
                <SubstrateOptionModal
                    programId={program.id}
                    closeModal={() => setOpenModal(false)}
                />
            )}
        </>
    );
};

export default ProgramSubstrateOptions;
